// Server binding includes wallet revision and exact follow relationships (including re-follow).
// Explicit fields also invalidate partial/legacy view updates that omit the opaque binding.
export const guardIdentity = data => JSON.stringify([
  data.guard_binding, data.configured, data.revision, data.paused, data.wallet_address,
  data.wallet_verified, data.wallet_verification_expires_at, data.limits,
  data.followed_bots, data.assets,
]);